module.exports = __webpack_public_path__ + "img/sender-du-ikke-lige-5.c2603a12.png";